import React, { useEffect, useRef, useState } from 'react';
import { Flex, Text } from '@smarterservices/smarter-ui';

const CountdownTimer = ({
  key = 'spCountdownTimer',
  duration = 600,
  label = null,
  onExpire,
}) => {
  const [remainingTime, setRemainingTime] = useState(duration);
  const timerRef = useRef(null);

  useEffect(() => {
    const startTime = JSON.parse(sessionStorage.getItem(key)) || Date.now();
    sessionStorage.setItem(key, JSON.stringify(startTime));

    const calculateRemainingTime = () => {
      const secondsElapsed = Math.floor((Date.now() - startTime) / 1000);
      // Using the max function so if they refresh after the timer goes off, it defaults to 0
      const newRemainingTime = Math.max(duration - secondsElapsed, 0);
      setRemainingTime(newRemainingTime);

      if (newRemainingTime === 0 && onExpire) {
        onExpire();
      }
    };

    calculateRemainingTime();

    // Update the remaining time every second to do a countdown
    timerRef.current = setInterval(calculateRemainingTime, 1000);

    return () => clearInterval(timerRef.current);
  }, [duration, onExpire]);

  return (
    <Flex direction="column" alignItems="center" padding="medium">
      {label && <Text size="large">{label}</Text>}
      <Text size="large">
        {Math.floor(remainingTime / 60)}:
        {(remainingTime % 60).toString().padStart(2, '0')}
      </Text>
    </Flex>
  );
};

export default CountdownTimer;
